import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ProductCompareActions from 'actions/ProductCompareActions';

/**
 * Hook to fetch product comparison data when modal opens
 * Handles SKU extraction, validation, and auto-close when all products are removed
 *
 * @param {boolean} isOpen - Whether the comparison modal is open
 * @param {Array} selectedProducts - Array of selected products to compare
 * @param {Function} onDismiss - Callback function to dismiss the modal
 *
 * @example
 * useComparisonFetch(isModalOpen, selectedProducts, dismissModal);
 */

const onFetchComparison = ProductCompareActions.fetchProductComparison;
const onClearComparisonData = ProductCompareActions.clearComparisonData;

export const useComparisonFetch = (isOpen, selectedProducts, onDismiss) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (isOpen) {
            if (selectedProducts.length >= 1) {
                // Extract and filter valid SKU IDs
                const skuIds = selectedProducts.filter(p => p?.currentSku?.skuId).map(p => p.currentSku.skuId);

                if (skuIds.length > 0) {
                    dispatch(onFetchComparison({ skuIds })).catch(err => Sephora.logger.verbose?.('compare fetch rejected', err));
                }
            } else {
                onDismiss();
            }
        } else {
            dispatch(onClearComparisonData());
        }
    }, [isOpen, selectedProducts, dispatch]);
};

export default useComparisonFetch;
